export const SubmitPositions = {
  DEFAULT: "default",
  SUB_FOOTER: "subFooter",
}
